const SERVICE_TYPE_ROUTES = {
  data: ["/data-catalog", "/discover-data", "/data-stewardship", "/donate-dataset"],
  models: ["/model-catalog"],
};

// Service paths handled by hardcoded routes (not dynamic service routes)
export const HARDCODED_SERVICE_PATHS = new Set([
  "/data-catalog",
  "/discover-data",
  "/data-stewardship",
  "/donate-dataset",
  "/staging-ticket",
  "/hpc-flows",
  "/software-catalog",
  "/model-catalog",
]);

function serviceMatchesRoute(service, routePath) {
  if (service.path === routePath) return true;
  if (!service.service_type) return false;
  const routes = SERVICE_TYPE_ROUTES[service.service_type];
  return routes ? routes.includes(routePath) : false;
}

function filterRoutesByServices(routes, services) {
  if (!Array.isArray(services) || services.length === 0) return [];
  return routes.filter((route) =>
    services.some((service) => serviceMatchesRoute(service, route.path)),
  );
}

export { SERVICE_TYPE_ROUTES, serviceMatchesRoute, filterRoutesByServices };
